import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

const Footer = () => (
  <footer className="bg-black text-white pt-16 pb-8 px-4 mt-auto">
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
      {/* Left: Company Info */}
      <div>
        <h3 className="font-sans text-xl font-light mb-2 text-white">Alpha Ahead Real Estate Brokerage</h3>
        <div className="mb-2 text-gray-300">Office 59, 2nd floor, first gulf business center, madina mall Muhaisnah, Dubai</div>
        <div className="mb-2 text-gray-300">info@alphaahead.estate</div>
        <div className="mb-1 text-gray-300">Mobile: <a href="tel:+971505606877" className="hover:text-accent transition-colors duration-200">+971 50 560 6877</a></div>
        <div className="mb-2 text-gray-300">Landline: <a href="tel:+97144323080" className="hover:text-accent transition-colors duration-200">+971 4 432 3080</a></div>
      </div>
      {/* Middle: Quick Links */}
      <div>
        <h4 className="font-sans text-lg font-light mb-2 text-white">Quick Links</h4>
        <ul className="space-y-2">
          <li><Link to="/communities" className="text-gray-300 hover:text-accent transition">Communities</Link></li>
          <li><Link to="/developers" className="text-gray-300 hover:text-accent transition">Developers</Link></li>
          <li><Link to="/about" className="text-gray-300 hover:text-accent transition">About Us</Link></li>
          <li><Link to="/contact" className="text-gray-300 hover:text-accent transition">Contact</Link></li>
        </ul>
      </div>
      {/* Right: Business Hours & Socials */}
      <div>
        <h4 className="font-sans text-lg font-light mb-2 text-white">Business Hours</h4>
        <div className="text-gray-300">Monday – Friday: 9:00 AM – 7:00 PM</div>
        <div className="text-gray-300">Saturday – Sunday: Closed</div>
        <div className="flex gap-4 mt-4">
          <a href="https://www.linkedin.com/company/alpha-ahead-estates/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-accent transition" aria-label="LinkedIn">
            <FaLinkedin className="w-6 h-6" />
          </a>
          <a href="https://www.instagram.com/alphaaheadestates/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-accent transition" aria-label="Instagram">
            <FaInstagram className="w-6 h-6" />
          </a>
          <a href="https://www.facebook.com/alphaaheadestates" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-accent transition" aria-label="Facebook">
            <FaFacebook className="w-6 h-6" />
            </a>
        </div>
      </div>
    </div>
    <div className="border-t border-gray-700 pt-6 text-center text-gray-400 text-sm">
      © 2025 Alpha Ahead Real Estate. All rights reserved.<br />Site built by <a href="https://alphaaheadllc.com/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-white transition-colors duration-200">Alpha Ahead</a>.
    </div>
  </footer>
);

export default Footer; 